import gql from 'graphql-tag';

export default gql`
mutation unlinkObjectives(
    $elementId: UUID!,
    $elementType: CoursewareElementType,
    $documentItems: [DocumentItemInputInput],
  ) {
    competencyDocumentItemUnlink (input: {
      elementId: $elementId,
      elementType: $elementType,
      documentItems: $documentItems
    }) {
      documentLink {
        elementId
        elementType
        documentItems {
          documentId
          documentItemId
        }
      }
    }
  }
`;
